// Time units. Base unit: seconds.

export type TimeUnitKey =
  | "ms" | "s" | "min" | "hr" | "day" | "week" | "month" | "year" | "decade" | "century";

export interface TimeUnit {
  key: TimeUnitKey;
  en: string;
  bn: string;
  shortEn: string;
  shortBn: string;
  seconds: number;
  note?: { en: string; bn: string };
}

export const TIME_UNITS: TimeUnit[] = [
  { key: "ms",      en: "Millisecond", bn: "মিলিসেকেন্ড", shortEn: "ms",   shortBn: "মি.সে.",  seconds: 0.001 },
  { key: "s",       en: "Second",      bn: "সেকেন্ড",     shortEn: "s",    shortBn: "সে.",     seconds: 1 },
  { key: "min",     en: "Minute",      bn: "মিনিট",       shortEn: "min",  shortBn: "মি.",     seconds: 60 },
  { key: "hr",      en: "Hour",        bn: "ঘণ্টা",       shortEn: "hr",   shortBn: "ঘ.",      seconds: 3600 },
  { key: "day",     en: "Day",         bn: "দিন",         shortEn: "day",  shortBn: "দিন",     seconds: 86400 },
  { key: "week",    en: "Week",        bn: "সপ্তাহ",     shortEn: "wk",   shortBn: "সপ্তাহ", seconds: 604800 },
  { key: "month",   en: "Month (avg)", bn: "মাস (গড়)",   shortEn: "mo",   shortBn: "মাস",     seconds: 2629746,
    note: { en: "Average 30.44 days (365.25 ÷ 12).", bn: "গড় ৩০.৪৪ দিন (৩৬৫.২৫ ÷ ১২)।" } },
  { key: "year",    en: "Year",        bn: "বছর",         shortEn: "yr",   shortBn: "বছর",     seconds: 31556952,
    note: { en: "Julian year ≈ 365.25 days.", bn: "জুলিয়ান বছর ≈ ৩৬৫.২৫ দিন।" } },
  { key: "decade",  en: "Decade",      bn: "দশক",         shortEn: "dec",  shortBn: "দশক",     seconds: 315569520 },
  { key: "century", en: "Century",     bn: "শতাব্দী",     shortEn: "cen",  shortBn: "শতাব্দী", seconds: 3155695200 },
];
